// extracted by mini-css-extract-plugin
export default {"container":"preloader_container__j8Gsp","preloader":"preloader_preloader__EuLhf"};